import type { TemplateProps } from "./types"
import { BaseTemplate } from "./BaseTemplate"

/** Bold Activist: high contrast, energetic. Red + black. Large typography. Strong CTAs. */
export function BoldActivistTemplate(props: TemplateProps) {
  const primary = props.customizations.primary_color ?? "#dc2626"
  const secondary = props.customizations.secondary_color ?? "#0a0a0a"

  return (
    <div
      className="font-sans antialiased [&_h1]:text-5xl [&_h1]:sm:text-6xl [&_h1]:md:text-7xl [&_h2]:text-3xl [&_h2]:sm:text-4xl"
      style={
        {
          "--primary-color": primary,
          "--secondary-color": secondary,
          fontFamily: props.customizations.font_family ?? "Inter, sans-serif",
        } as React.CSSProperties
      }
    >
      <BaseTemplate {...props} />
    </div>
  )
}
